export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-4.70741c82.png";